import { useContext } from 'react';

import { HoneycombLabelsDisplayContext } from '../context/honeycomb-labels-display.context.js';
import type { HoneycombLabelsDisplay } from '../types/honeycomb.js';

export const useHoneycombLabelsDisplay = (): HoneycombLabelsDisplay =>
  useContext(HoneycombLabelsDisplayContext);
